import { useCallback } from "react";
import { useNavigate } from "react-router";

export const useAnimatedNavigate = () => {
    const navigate = useNavigate();
    return useCallback((url) => {
        try {
            if (!document.startViewTransition) {
                navigate(url);
            } else {
                document.startViewTransition(() => {
                    navigate(url);
                });
            }
        } catch (error) {
            console.error(error);
        }
    }, [navigate]);
}
